export default class RequesterData {
  name = ''
  county = ''
  city = ''
  address = ''
  email = ''
  phone = ''

  replacer = (key: any, value: any) => { // eslint-disable-line
    if (key !== 'rules') return value
  }

  rules = {
    name: [
      (v: string) => !!(v.trim()) || 'A név megadása kötelező!',
      (v: string) => v.trim().length > 5 || 'Túl rövid név!'
    ],
    county: [
      (v: string) => !!(v.trim()) || 'A megye megadása kötelező!'
    ],
    city: [
      (v: string) => !!(v.trim()) || 'A település megadása kötelező!'
    ],
    email: [
      (v: string) => !!(v.trim()) || 'Az e-mail cím megadása kötelező!',
      (v: string) => /.+@.+\..{2,6}$/.test(v) || 'Érvénytelen e-mail cím!'
    ],
    phone: [
      (v: string) => !!(v.trim()) || 'A telefonszám megadása kötelező!',
      (v: string) => v.trim().length > 5 || 'Túl rövid telefonszám!'
    ]
  }
}
